import { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navigation from "../Components/Navigation";
import Api from "../Services/Api";
import { Col, Container, Row, Table } from "react-bootstrap";
import dayjs from "dayjs";
import RequireLoginComponent from "../Components/RequireLoginComponent";

interface HealthFair {
  id: number;
  companyId: number;
  name: string;
  uuid: string;
  startDate: string;
  endDate: string;
  createdAt: string;
  updatedAt: string;
}

const HealthFairs = () => {
  const navigate = useNavigate();
  const [data, setData] = useState(false);
  const [healthFairs, setHealthFairs] = useState<HealthFair[]>([]);
  const [isNotAuthenticated, setIsNotAuthenticated] = useState(false);
  useEffect(() => {
    window.rudderanalytics.page("Health Fairs");
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("staffToken");
    if (!token) {
      setIsNotAuthenticated(true);
    } else {
      setIsNotAuthenticated(false);
    }
  }, []);

  useEffect(() => {
    if (!data) {
      const api = new Api();
      const healthFairsData = api.getHealthFairs();
      healthFairsData
        .then((result) => {
          if (result) {
            setHealthFairs(result);
          }
        })
        .catch((ex) => {
          console.log(ex);
        });
      setData(true);
    }
  }, [data]);

  const formatDate = (dateString: string): string => {
    return dayjs(dateString).format("DD-MM-YYYY");
  };

  const handleRowClick = (uuid: string) => {
    navigate(`/health-fairs/${uuid}/participants`);
  };

  return (
    <Fragment>
      <Navigation />
      <Container className="mt-4">
        <RequireLoginComponent isNotAuthenticated={isNotAuthenticated} />
        {!isNotAuthenticated && (
          <>
            <Row>
              <Col>
                <h1>Health Fairs</h1>
              </Col>
            </Row>
            <Row className="mt-4">
              <Table bordered={false} striped={true} hover>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>UUID</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                  </tr>
                </thead>
                <tbody>
                  {healthFairs.map((healthFair: HealthFair) => {
                    return (
                      <tr 
                        key={healthFair.id}
                        onClick={() => handleRowClick(healthFair.uuid)}
                        style={{ cursor: 'pointer' }}
                      >
                        <td>{healthFair.name}</td>
                        <td>{healthFair.uuid}</td>
                        <td>{formatDate(healthFair.startDate)}</td>
                        <td>{formatDate(healthFair.endDate)}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </Row>
          </>
        )}
      </Container>
    </Fragment>
  );
};

export default HealthFairs;

